import { Component, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { fadeInUp400ms } from '@vex/animations/fade-in-up.animation';
import { MatButtonModule } from '@angular/material/button';
import { NgIf } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AuthService } from 'src/app/services/auth.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'vex-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  animations: [fadeInUp400ms],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    NgIf,
    MatButtonModule
  ]
})
export class ForgotPasswordComponent implements OnInit {
  form = this.fb.group({
    email: [null, Validators.email]
  });

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private authService: AuthService,
    private snackbar: SnackbarService,
  ) {}

  ngOnInit() {}

  sendPasswordResetEmail() {
    if (this.form.valid) {
      this.authService.sendPasswordResetEmail(this.form.controls.email.value || '').then(() => {
        this.snackbar.success('Please check your inbox for password reset instructions.');
        this.router.navigate(['/sign-in']);
      }).catch((error) => {
        this.snackbar.error(error);
      })
    } else {
      this.snackbar.error('Please provide a valid email address.')
    }
    
  }
}
